import { render, staticRenderFns } from "./Mypayment.vue?vue&type=template&id=31676272&scoped=true"
import script from "./Mypayment.vue?vue&type=script&lang=js"
export * from "./Mypayment.vue?vue&type=script&lang=js"
import style0 from "./Mypayment.vue?vue&type=style&index=0&id=31676272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31676272",
  null
  
)

export default component.exports